import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import Slick from 'slick-carousel/slick/slick.js';
import ScrollReveal from "scrollreveal";
import slickLightBox from "slick-lightbox";
import modaal from 'modaal';


import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"
import SlickCss from 'slick-carousel/slick/slick.scss';
import SlickThemeCss from 'slick-carousel/slick/slick-theme.scss';
import accordion from "./app/accordion";
import slickLightboxCss from "slick-lightbox/src/styles/slick-lightbox.sass";
import modaalCss from 'modaal/source/css/modaal.scss';

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    // --------------------------------------------------------------- OwlCarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 800,
          dotsSpeed: 800,
          dragEndSpeed: 800,
          autoWidth: false,
          autoHeight: false,
          center: true,
          // animateOut: 'fadeOut',
          onInitialized: bannerSlick,
          // navText: ['<img src="../assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カルーセル

      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="../assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-voice-slider').owlCarousel({
          margin: 16,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 1200,
          navSpeed: 1200,
          dotsSpeed: 1200,
          dragEndSpeed: 1200,
          autoWidth: false,
          autoHeight: true,
          center: true,
          onInitialized: onInitialized,
          onTranslate: onTranslate,
          // autoHeightClass: 'owl-height',
          navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 1,
            }
          }
        });
      });

      function bannerSlick() {
        setTimeout(function(){
          $('.js-banner-slider').addClass('is-active');
          // $('.js-banner-slider').imagesLoaded( function() {
          $('.js-banner-slider').slick({
            infinite: true,
            centerMode: true,
            centerPadding: '18.5%',
            slidesToShow: 1,
            dots: true,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 1200,
            responsive: [
              {
                breakpoint: 750,
                settings: {
                  centerPadding: '11%',
                }
              },
              {
                breakpoint: 375,
                settings: {

                  }
              }
            ]
          });
        // });
        },500);

      }

      function onInitialized(e) {
        var lengthNum = '0' + e.item.count;
        var currentNum = '0' + (e.page.count + 1);
        $('.c-hero-block__num span.is-current').text(currentNum);
        $('.c-hero-block__num span.is-length').text(lengthNum);
      }

      function onTranslate(e) {
        var currentNum = '0' +  (e.page.index + 1);
        $('.c-hero-block__num span.is-current').text(currentNum);
      }
    }

    // --------------------------------------------------------------- Slick
    function slick() {
      // $('.js-banner-slider').slick({
      //   infinite: true,
      //   centerMode: true,
      //   centerPadding: '18.5%',
      //   slidesToShow: 1,
      //   dots: true,
      //   arrows: true,
      //   autoplay: true,
      //   autoplaySpeed: 4000,
      //   speed: 1200,
      //   responsive: [
      //     {
      //       breakpoint: 750,
      //       settings: {
      //         centerPadding: '11%',
      //       }
      //     },
      //     {
      //       breakpoint: 375,
      //       settings: {

      //       }
      //     }
      //   ]
      // });



      // --------------------------------------------------------------- Gallery
      var slider = '.js-slider';
      var thumbItem = '.js-thumb-item';

      // データ属性の数字を割り振る
      $(thumbItem).each(function () {
        var index = $(thumbItem).index(this);
        $(this).attr("data-index", index);
      });

      //スライダー初期化
      $(slider).on('init',function(slick) {
        var index = $('.slide-item.slick-slide.slick-current').attr("data-slick-index");
        $(thumbItem + ':first-child').addClass('thumb-current');
      });

      // オプション
      $(slider).slick({
        speed: 1000,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        // asNavFor: '.js-thumb',
        centerMode: true,
        variableWidth: false,
        centerPadding: '16.2%',
        accessibility: false,
        arrows: true,
        appendDots: '.c-gallery-dots',
        responsive:[
          {
            breakpoint: 751,
            settings: {
              centerPadding: '0',
            }
          },
          {
            breakpoint: 951,
            settings: {
              centerPadding: '12.5%',
            }
          },
          {
            breakpoint: 1401,
            settings: {
              centerPadding: '16.2%',
            }
          },
          {
            breakpoint: 1921,
            settings: {
              centerPadding: '23.4%',
            }
          },
        ]
      });
      //サムネイルをクリックした時スライダー切り替え
      $(thumbItem).on('click',function(){
        var index = $(this).attr("data-index");
        $(slider).slick("slickGoTo",index,false);
      });

      //サムネイル画像のカレントを切り替え
      $(slider).on('beforeChange',function(event,slick, currentSlide,nextSlide){
        $(thumbItem).each(function(){
          $(this).removeClass("thumb-current");
        });
        $(thumbItem+'[data-index="'+nextSlide+'"]').addClass("thumb-current");
      });

      // ------------------------------------------------------------------- Details slider

      var sliderMain = "";
      var thumb = '.js-thumb';

      $('.js-slider-main').each(function (i, elm) {
        var $slider_area = $(elm).parent();
        var $main_slide = $slider_area.find(".js-slider-main");
        var $thumb_slide = $slider_area.find(".js-thumb");


        // データ属性の数字を割り振る
        $thumb_slide.find('.js-thumb-item').each(function () {
          var index = $thumb_slide.find('.js-thumb-item').index(this);
          $(this).attr("data-index", index);
        });

        // 初期化
        $main_slide.on('init',function(slick) {
          $thumb_slide.find(".js-thumb-item:first-child").addClass('thumb-current');
        });

        // サムネイルをクリックした時スライダー切り替え
        $thumb_slide.find(".js-thumb-item").on('click',function(){
          var index = $(this).attr("data-index");
          $main_slide.slick("slickGoTo",index,false);
        });

        // サムネイル画像のカレントを切り替え
        $main_slide.on('beforeChange',function(event,slick, currentSlide,nextSlide){
          $thumb_slide.find(".js-thumb-item").removeClass("thumb-current");
          console.log(currentSlide);
          $thumb_slide.find('.js-thumb-item[data-index="'+nextSlide+'"]').addClass("thumb-current");
        });

        // オプション
        $main_slide.slick({
          dots: false,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          // asNavFor: '.js-thumb',
          variableWidth: false,
          accessibility: false,
          arrows: false,
          appendDots: '.c-gallery-dots',
          responsive:[
            {
              breakpoint: 751,
              settings: {
              }
            },
            {
              breakpoint: 951,
              settings: {
              }
            },
            {
              breakpoint: 1401,
              settings: {
              }
            },
          ]
        });
      });
    }


    // ------------------------------------------------- よくあるご質問表示数制御

    function faqVisibleSwitch() {
      // もっと見るボタンをクリックしたら、全てのご質問を表示する
      $('.c-faq-accordion__button').on('click', function() {
        $(this).toggleClass('is-open');
        $('.c-accordion').toggleClass('is-visible');
      });

      // よくあるご質問が5個より多くなった場合、もっと見るボタンを表示する
      if ( $('.c-accordion__block').length > 5 ) {
        $('.c-faq-accordion__button').show();
      } else {
        $('.c-faq-accordion__button').hide();
      }
    }


    // ------------------------------------------------- スクロールリーバル

    function reveal() {
      //- スクロールリーバル
      window.sr = ScrollReveal({duration: 600,mobile:false});
      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }


      sr.reveal(".c-main-visual", {scale: 1, duration: 1500,origin:'bottom',distance: '0',easing: 'cubic-bezier(0.77, 0, 0.175, 1)'}, 100);
      sr.reveal(".l-page-header", {scale: 1, duration: 600,origin:'bottom',distance: '0',easing: 'cubic-bezier(0.77, 0, 0.175, 1)'}, 100);
      sr.reveal(".c-main-visual__inner", {scale: 1, duration: 600,delay: '500',origin:'left',distance: '20px',easing: 'cubic-bezier(0.77, 0, 0.175, 1)'}, 100);
      sr.reveal(".l-page-header__inner", {scale: 1, duration: 300,delay: '200',origin:'left',distance: '20px',easing: 'cubic-bezier(0.77, 0, 0.175, 1)'}, 100);
      // sr.reveal(".c-full-block__image", {viewFactor: 0.6,scale: 1, duration: 600,delay: '0',origin:'left',distance: '0',easing: 'cubic-bezier(0.77, 0, 0.175, 1)'}, 100);

      // var blocks01 = $(".c-super-block__block");
      // domEach(blocks01, function (key, item) {
      //   sr.reveal(item, {viewFactor: 0.6,delay: 0,duration: 300,scale: 1,origin: 'bottom', distance: '20px',easing: 'cubic-bezier(0.77, 0, 0.175, 1)'}, 100);
      //   sr.reveal(item.children[1], {viewFactor: 0.6,delay: 100, scale: 1,origin: 'bottom', distance: '20px',easing: 'cubic-bezier(0.77, 0, 0.175, 1)'}, 100);
      //   sr.reveal(item.children[2], {viewFactor: 0.6,delay: 200, scale: 1,origin: 'bottom', distance: '20px',easing: 'cubic-bezier(0.77, 0, 0.175, 1)'}, 100);
      //   sr.reveal(item.children[3], {viewFactor: 0.6,delay: 300, scale: 1,origin: 'bottom', distance: '20px',easing: 'cubic-bezier(0.77, 0, 0.175, 1)'}, 100);
      //   sr.reveal(item.children[4], {viewFactor: 0.6,delay: 400, scale: 1,origin: 'bottom', distance: '20px',easing: 'cubic-bezier(0.77, 0, 0.175, 1)'}, 100);
      //   sr.reveal(item.children[5], {viewFactor: 0.6,delay: 500, scale: 1,origin: 'bottom', distance: '20px',easing: 'cubic-bezier(0.77, 0, 0.175, 1)'}, 100);
      // });

      function myCallback (el) {
        el.classList.add('is-animating');
      }

      ScrollReveal().reveal('#example', { beforeReveal: myCallback });/**/
    }



    $(function () {
      menuSlide();
      owlCarousel();
      slick();
      faqVisibleSwitch();
      reveal();
      $('.c-floormap__zoom').modaal({
        type: 'image'
      });
      $('.js-zoom-content').modaal({});
    });
  }
}

window.GApp = new App();
